<template>
  <div class="d-flex flex-nowrap justify-space-between">
    <div v-if="type === 'booth'"
      :style="'flex: 1; ' + (timeSlot.type !== CUSTOMER.TYPE_FORM.IN_HOUSE_MATCH ? 'cursor: pointer;' : '')"
      @click="timeSlot.type !== CUSTOMER.TYPE_FORM.IN_HOUSE_MATCH ? redirectToHistory(timeSlot.customer_id, timeSlot.id) : null">
      <div :class="'d-flex justify-space-between ' + (computedIsKindUsageProhibited ? 'justify-center red' : '')">
        <div v-bind:title="getKindShortName(timeSlot)"
          :class="'text-center text-caption max-h-40 ' + timeSlot.color + ' ' + computedKindTextColor + computedColorForKindUsageProhibited + computedConnectFlagTextColor"
          :style="{ flexShrink: 0, paddingLeft: '2px', paddingRight: '2px' }">
          {{ getKindShortName(timeSlot) }}
        </div>
        <div v-bind:title="timeSlot.counselor.name" class="text-center px-1 text-caption" v-if="timeSlot.type !== CUSTOMER.TYPE_FORM.IN_HOUSE_MATCH && !computedIsKindUsageProhibited">
          {{ timeSlot.counselor.name.substring(0, 2) }}
        </div>
        <div :class="'px-1 text-caption max-h-40 mb-custom ' + (!computedIsKindUsageProhibitedAndStatusNotImplemented ? CUSTOMER.STATUS_MATCHING_LEDGER_V2.getValue(timeSlot.confirmed_day_before ? -1 : timeSlot.status, true) : 'white text-red')">
          {{ timeSlot.confirmed_day_before ? CUSTOMER.STATUS_MATCHING_LEDGER_V2.getValue(-1) : CUSTOMER.STATUS_MATCHING_LEDGER_V2.getValue(timeSlot.status).substring(0, 1) }}
        </div>
      </div>
      <div v-if="timeSlot.type === CUSTOMER.TYPE_FORM.IN_HOUSE_MATCH">
        <div v-if="timeSlot.female_customer.hasOwnProperty('id')"
          class="text-center pd-1 text-caption text-truncate-custom" style="cursor: pointer; flex: 1"
          @click="redirectToHistory(timeSlot.female_customer.id, timeSlot.female_customer.customer_history_id)">
          {{ onlinePrefix + customerName(timeSlot.female_customer) }}{{ computedCOShortName }}
        </div>
        <div v-if="timeSlot.male_customer.hasOwnProperty('id')" style="cursor: pointer; flex: 1"
          @click="redirectToHistory(timeSlot.male_customer.id, timeSlot.male_customer.customer_history_id)">
          <div class="text-center pd-1 text-caption text-truncate-custom text-red" v-if="[CUSTOMER.FUKUOKA_MALE.id, CUSTOMER.HIROSHIMA_MALE.id].includes(timeSlot.customer_id)">
            {{ getCustomerSpecific(timeSlot.customer_id) }}{{ computedCO2ShortName }}
          </div>
          <div class="text-center pd-1 text-caption text-truncate-custom" v-else>
            {{ customerName(timeSlot.customer) }}{{ computedCO2ShortName }}
          </div>
        </div>
      </div>

      <div v-else>
        <div v-if="!computedIsKindUsageProhibited">
          <div v-if="timeSlot.customer.hasOwnProperty('gender') && !timeSlot.female_customer.hasOwnProperty('id') && !computedIsKindAdvise && !computedIsKindWomanFirst">
            <div class="text-center pd-1 text-caption text-truncate-custom text-red" v-if="[CUSTOMER.FUKUOKA_MALE.id, CUSTOMER.HIROSHIMA_MALE.id].includes(timeSlot.customer_id)">
              {{ onlinePrefix + getCustomerSpecific(timeSlot.customer_id) }}
            </div>
            <div class="text-center pd-1 text-caption text-truncate-custom" v-else>
              {{ onlinePrefix + customerName(timeSlot.customer) }}
            </div>
          </div>
          <div v-if="computedIsKindAdvise || computedIsKindWomanFirst" class=" text-start ps-1 text-caption">
            {{ computedShortNote }}
          </div>
        </div>
        <div v-else class="red text-start ps-1 text-caption">
          {{ computedShortNote }}
        </div>
      </div>
      <!-- 4行目: メモの頭6文字（見合いブースのみ・使用不可/AD面談/女性初回を除く） -->
      <div v-if="timeSlot.note && !computedIsKindUsageProhibited && !computedIsKindAdvise && !computedIsKindWomanFirst"
        class="text-center pd-1 text-caption text-truncate-custom">
        {{ timeSlot.note.substring(0, 6) }}
      </div>
    </div>
    <div v-else style="cursor: pointer" @click="redirectToHistory(timeSlot.customer_id, timeSlot.id)" :class="computedIsKindUsageProhibited ? 'w-100' : ''">
      <div class="d-flex">
        <div v-bind:title="timeSlot.booth.name" class="text-caption px-1 max-w-96">
          {{ timeSlot.booth.name }}
        </div>
        <div :class="'px-1 text-caption max-h-40 min-w-33 mb-custom ' + CUSTOMER.STATUS_MATCHING_LEDGER.getValue(timeSlot.confirmed_day_before ? -1 : timeSlot.status, true)">
          {{ timeSlot.confirmed_day_before ? CUSTOMER.STATUS_MATCHING_LEDGER.getValue(-1) : CUSTOMER.STATUS_MATCHING_LEDGER.getValue(timeSlot.status) }}
        </div>
      </div>
      <div v-bind:title="getKindName(timeSlot)"
        :class="'text-center pd-1 text-caption text-truncate-custom ' + timeSlot.color + ' ' + computedKindTextColor + computedColorForKindUsageProhibited + computedConnectFlagTextColor">
        {{ getKindName(timeSlot) }}
      </div>
      <div v-if="!computedIsKindUsageProhibited">
        <div v-if="!computedIsKindAdvise && !computedIsKindWomanFirst" v-bind:title="timeSlot.name">
          <div class="text-center pd-1 text-caption text-truncate-custom text-red" v-if="[CUSTOMER.FUKUOKA_MALE.id, CUSTOMER.HIROSHIMA_MALE.id].includes(timeSlot.customer_id)">
            {{ onlinePrefix + getCustomerSpecific(timeSlot.customer_id) }}
          </div>
          <div class="text-center pd-1 text-caption text-truncate-custom" v-else>
            {{ onlinePrefix + customerName(timeSlot.customer) }}
          </div>
        </div>
        <div v-if="computedIsKindAdvise || computedIsKindWomanFirst" class=" text-start ps-1 text-caption">
          {{ computedShortNote }}
        </div>
      </div>
      <div v-else class="red text-start ps-1 text-caption">
        {{ computedShortNote }}
      </div>
    </div>
    <div v-if="timeSlot.isSame" class="cyan lighten-1 d-flex flex-column justify-space-between duplicate-plan" @click="getDuplicateAppointment(timeSlot, timeRange, isBoothNo)"
      style="padding: 2px; font-size: 11px; min-width: 26px; cursor: pointer;">
      <span>重複</span><span>予定</span><span>あり</span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CUSTOMER from "@/consts/customer.js";

export default {
  title: 'お見合い台帳',
  name: 'MatchingLedgerItem',
  props: ['timeSlot', 'type', 'counselorMasters', 'timeRange', 'isBoothNo'],
  data: () => ({
    CUSTOMER: CUSTOMER,
    appointmentData: {},
  }),
  computed: {
    computedKindTextColor() {
      return this.timeSlot.color === 'black' ? 'text-white' : 'text-dark'
    },
    computedCOShortName() {
      const foundCounselor = this.counselorMasters.find(counselor => counselor.id === this.timeSlot.female_customer.counselor_id)
      return foundCounselor ? `/${foundCounselor.name.substring(0, 2)}`  : ''
    },
    computedCO2ShortName() {
      const foundCounselor = this.counselorMasters.find(counselor => counselor.id === this.timeSlot.male_customer.counselor_id)
      return foundCounselor ? `/${foundCounselor.name.substring(0, 2)}` : ''
    },
    computedColorForKindUsageProhibited() {
      return this.computedIsKindUsageProhibited ? ' text-white' : ''
    },
    computedIsKindUsageProhibited() {
      return this.timeSlot.kind === CUSTOMER.KINDS_FOR_COMPANY_VISIT.VAL.USAGE_PROHIBITED
    },
    computedIsKindAdvise() {
      return this.timeSlot.kind === CUSTOMER.KINDS_FOR_COMPANY_VISIT.VAL.ADVISE
    },
    computedIsKindWomanFirst() {
      return this.timeSlot.kind === CUSTOMER.KINDS_FOR_COMPANY_VISIT.VAL.WOMAN_FIRST
    },
    computedIsKindUsageProhibitedAndStatusNotImplemented() {
      return this.timeSlot.kind === CUSTOMER.KINDS_FOR_COMPANY_VISIT.VAL.USAGE_PROHIBITED && this.timeSlot.status === CUSTOMER.STATUS_MATCHING_LEDGER_V2.getValueByText('仮予定')
    },
    computedShortNote() {
      return this.timeSlot.note.length > 10
        ? this.timeSlot.note.substring(0, 10) + '...'
        : this.timeSlot.note
    },
    computedConnectFlagTextColor() {
      // 連盟見合の場合は文字色を白に設定
      if (this.timeSlot.kind === this.CUSTOMER.EXEC_KIND.VAL.CS_MATCHING && this.timeSlot.connect_flag) {
        return ' text-white';
      }
      return '';
    },
    onlinePrefix() {
      return this.timeSlot.is_online ? 'On ' : ''
    },
  },
  methods: {
    customerName(customer) {
      return (customer.family_name !== "-" ? customer.family_name : '') + ' ' + (customer.given_name !== "-" ? customer.given_name : '')
    },

    getCustomerSpecific(customer_id) {
      if(CUSTOMER.FUKUOKA_MALE.id === customer_id) {
        return CUSTOMER.FUKUOKA_MALE.name
      }
      return CUSTOMER.HIROSHIMA_MALE.name
    },
    redirectToHistory(customerId, query) {
      const routeData = this.$router.resolve({ name: 'customer_history', params: { id: customerId }, query: { id: query, fromScreen: 'ledger' } })
      window.open(routeData.href, '_blank');
    },
    getDuplicateAppointment(appointment, timeRange, isBoothNo) {
      this.$axios.get("/api/v1/customer/duplicate-appointment",  {
        params: {
          isBoothNo: isBoothNo,
          target_date: appointment.target_date,
          target_time: appointment.target_time,
          target_time_end: appointment.target_time_end,
          booth_no_id: appointment.booth_no_id,
          booth_no2_id: appointment.booth_no2_id,
          counselor_id: appointment.counselor_id,
          counselor2_id: appointment.counselor2_id,
          historyId: appointment.id,
          timeRangeStart: moment(timeRange.value, "HH:mm:ss").startOf('hour').format("HH:mm:ss"),
          timeRangeEnd: moment(timeRange.value, "HH:mm:ss").endOf('hour').format("HH:mm:ss")
        }
      })
      .then((response) => {
        if (response.data.conflictingAppointmentRes) {
          this.$emit('open-modal', response.data.conflictingAppointmentRes);
        }
      })
      .catch((error) => {
        console.log("Error : " + error);
      });
    },
    // 連盟見合の場合、connect_flagに基づいた短縮名を返す
    getKindShortName(timeSlot) {
      if (timeSlot.kind === this.CUSTOMER.EXEC_KIND.VAL.CS_MATCHING && timeSlot.connect_flag) {
        return timeSlot.connect_flag === this.CUSTOMER.CONNECT_FLAG.VAL.CONNECT ? 'コネ見' : 'IBJ見';
      }
      return this.CUSTOMER.EXEC_KIND.getShort(timeSlot.kind);
    },
    // 連盟見合の場合、connect_flagに基づいた名称を返す（getKindShortNameと同じロジック）
    getKindName(timeSlot) {
      return this.getKindShortName(timeSlot);
    },
  },
  watch: {}
}
</script>

<style scoped lang="scss">
.pd-1 {
  padding-left: 1px;
}

.mb-custom {
  margin-bottom: 1px;
}

.duplicate-plan {
  margin-left: 1px;
}

.max-h-40 {
  display: flex;
  align-items: center;
  max-height: 40px;
}

.min-w-33 {
  min-width: 33px;
}

.max-w-96 {
  max-width: 96px;
}

.text-truncate-custom {
  display: flex;
  align-items: center;
  justify-content: center;
}

.cyan {
  background: #00FFFF
}

.text-white {
  color: white;
}
.text-red {
  color: red;
}

.lighten-pink {
  background: #f969b5;
}
.w-100 {
  width: 100%;
}
.low-blue {
  background-color: #B0C4DE;
}
</style>
